<template>
    <div class="agent-page">
        <div class="page-header">
            <div style="display: flex; flex-direction: column; text-align: start;">
                <h2 class="page-title">{{ projectTitle }}</h2>
                <h2 class="page-title" style="margin-top: 10px;">解答投标人问题</h2>
            </div>
            <el-button type="primary" icon="el-icon-arrow-left" @click="handleBack">返回项目流程界面</el-button>
        </div>

        <div class="table-section">
                <el-table :data="tableData" style="width: 100%" :show-header="true" border class="question-table">
                    <el-table-column prop="no" label="NO." align="left" header-align="left" width="80">
                    </el-table-column>
                    <el-table-column prop="questionTitle" label="问题标题" align="center" header-align="center"
                        min-width="200">
                    </el-table-column>
                    <el-table-column prop="questionContent" label="问题内容" align="center" header-align="center"
                        min-width="300">
                    </el-table-column>
                    <el-table-column prop="submitTime" label="提交时间" align="center" header-align="center"
                        min-width="160">
                    </el-table-column>
                    <el-table-column prop="status" label="状态" align="center" header-align="center" min-width="120">
                    </el-table-column>
                    <el-table-column prop="operation" label="操作" align="center" header-align="center" width="200">
                        <template slot-scope="scope">
                            <el-button type="text" size="small" @click="handleAnswer(scope.row)"
                                style="margin-right: 10px;">
                                解答
                            </el-button>
                            <!-- <el-button type="text" size="small" @click="handleView(scope.row)">
                                查看
                            </el-button> -->
                        </template>
                    </el-table-column>
                </el-table>

            <!-- 分页区域 -->
            <div class="pagination-section">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page="currentPage" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize"
                    layout="total, sizes, prev, pager, next, jumper" :total="total" class="pagination" />
            </div>
        </div>

        <!-- 回复弹窗 -->
        <el-dialog title="回复投标人问题" :visible.sync="replyDialog.visible" width="750px" :close-on-click-modal="false">
            <el-form :model="replyDialog.form" :rules="replyDialog.rules" ref="replyForm" label-width="120px" size="small">
                <!-- 问题信息区域 -->
                <div class="question-info-section">
                    <el-form-item label="问题标题:">
                        <div class="info-text">{{ replyDialog.questionTitle }}</div>
                    </el-form-item>
                    <el-form-item label="问题内容:">
                        <div class="info-text question-content">{{ replyDialog.questionContent }}</div>
                    </el-form-item>
                    
                    <!-- 问题附件（只读查看） -->
                    <el-form-item label="问题附件:" v-if="replyDialog.questionFiles.length > 0">
                        <div class="file-list-readonly">
                            <div v-for="file in replyDialog.questionFiles" :key="file.fileId" class="file-item-readonly">
                                <i class="el-icon-document"></i>
                                <span class="file-name" :title="file.fileName">{{ file.fileName }}</span>
                                <span class="file-size">{{ formatFileSize(file.fileSize) }}</span>
                                <el-button type="text" size="mini" @click="handleDownloadFile(file)">
                                    <i class="el-icon-download"></i> 下载
                                </el-button>
                            </div>
                        </div>
                    </el-form-item>
                    <el-form-item label="问题附件:" v-else>
                        <div class="no-files">无附件</div>
                    </el-form-item>
                </div>

                <el-divider></el-divider>

                <!-- 回复信息区域 -->
                <div class="reply-info-section">
                    <el-form-item label="答复内容:" prop="replyContent">
                        <el-input 
                            type="textarea" 
                            v-model="replyDialog.form.replyContent" 
                            :rows="4"
                            maxlength="500"
                            show-word-limit
                            placeholder="请输入答复内容">
                        </el-input>
                    </el-form-item>
                    
                    <el-row :gutter="16">
                        <el-col :span="12">
                            <el-form-item label="答复联系人:" prop="replyContact">
                                <el-input v-model="replyDialog.form.replyContact" placeholder="请输入答复联系人"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="联系人手机:" prop="replyPhone">
                                <el-input v-model="replyDialog.form.replyPhone" placeholder="请输入联系人手机号"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 回复附件（可上传） -->
                    <el-form-item label="答复附件:">
                        <div class="upload-section">
                            <el-upload
                                class="upload-area"
                                action="#"
                                :auto-upload="false"
                                :on-change="handleReplyFileChange"
                                :on-remove="handleReplyFileRemove"
                                :file-list="replyDialog.replyFileList"
                                :limit="5"
                                :on-exceed="handleFileExceed">
                                <el-button size="small" type="primary" icon="el-icon-upload2">选择文件</el-button>
                                <div slot="tip" class="upload-tip">
                                    <i class="el-icon-info"></i> 支持上传多个文件，单个文件不超过100MB，最多5个文件
                                </div>
                            </el-upload>
                            <div v-if="replyDialog.uploadProgress > 0 && replyDialog.uploadProgress < 100" class="upload-progress">
                                <el-progress :percentage="replyDialog.uploadProgress" :stroke-width="6"></el-progress>
                            </div>
                        </div>
                    </el-form-item>
                </div>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="handleCancelReply" :disabled="replyDialog.submitting">取消</el-button>
                <el-button type="primary" @click="handleSubmitReply" :loading="replyDialog.submitting">提交回复</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { loadProjectDetail } from '@/utils/projectInfo.js'
import { getComplainList, submitComplainReply, getComplainDetail } from '@/api/createComplain/api'
import { getFileList } from '@/api/base/api'
import { doFileUpload } from '@/utils/fileUploadHelper'

export default {
    name: 'AnswerBidderQuestions',
    data() {
        return {
            projectCode: this.$route.query.projectCode,
            projectTitle: '',
            complaintType: 'bidDoc',
            tableData: [],
            currentPage: 1,
            pageSize: 10,
            total: 0,
            jumpPage: 1,

            // 回复弹窗
            replyDialog: {
                visible: false,
                submitting: false,
                complaintCode: '',
                questionTitle: '',
                questionContent: '',
                questionFiles: [], // 问题附件列表（只读）
                replyFileList: [], // 回复附件列表（可上传）
                uploadProgress: 0,
                form: {
                    replyContent: '',
                    replyContact: '',
                    replyPhone: '',
                    replyFileGuid: ''
                },
                rules: {
                    replyContent: [
                        { required: true, message: '请输入答复内容', trigger: 'blur' }
                    ],
                    replyContact: [
                        { required: true, message: '请输入答复联系人', trigger: 'blur' }
                    ],
                    replyPhone: [
                        { required: true, message: '请输入联系人手机号', trigger: 'blur' },
                        { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }
                    ]
                }
            }
        }
    },
    mounted() {
        this.getProjectInfo()
        this.getComplainList()

    },
    methods: {
        // 获取列表
        async getComplainList() {
            let data = {
                complaintType: this.complaintType,
                projectCode: this.projectCode,
                pageNum: this.currentPage,
                pageSize: this.pageSize,
                stage: 0
            }
            const res = await getComplainList(this.complaintType, data)
            if (res.code === 200) {
                const records = res.data.records || []
                this.total = res.data.total || 0

                // 映射数据到表格
                this.tableData = records.map((item, index) => {
                    // 状态映射：0-待回复，1-已回复
                    let statusText = '待回复'
                    if (item.status === 2) {
                        statusText = '已回复'
                    }

                    return {
                        no: (this.currentPage - 1) * this.pageSize + index + 1,
                        questionTitle: item.title || '',
                        questionContent: item.content || '',
                        submitTime: item.submitTime || '',
                        status: statusText,
                        bidSectionName: item.bidSectionName || '',
                        complaintCode: item.complaintCode,
                        rawStatus: item.status,
                        submitUserName: item.submitUserName || ''
                    }
                })
            } else {
                this.$message.error(res.msg)
            }
        },

        // 获取项目信息
        async getProjectInfo() {
            try {
                this.projectTitle = await loadProjectDetail(this.projectCode)
            } catch (error) {
                console.error('获取项目信息失败:', error)
            }
        },

        // 格式化文件大小
        formatFileSize(bytes) {
            if (!bytes) return '0 B'
            const k = 1024
            const sizes = ['B', 'KB', 'MB', 'GB']
            const i = Math.floor(Math.log(bytes) / Math.log(k))
            return (bytes / Math.pow(k, i)).toFixed(2) + ' ' + sizes[i]
        },

        // 下载问题附件
        handleDownloadFile(file) {
            window.open(file.fileUrl, '_blank')
        },

        // 回复附件选择
        handleReplyFileChange(file, fileList) {
            this.replyDialog.replyFileList = fileList
        },

        // 回复附件移除
        handleReplyFileRemove(file, fileList) {
            this.replyDialog.replyFileList = fileList
        },

        // 文件数量超限
        handleFileExceed() {
            this.$message.warning('最多只能上传5个文件')
        },
        // 返回项目流程界面
        handleBack() {
            this.$router.go(-1)
        },

        // 解答按钮点击
        handleAnswer(row) {
            // // 如果已回复，提示不能重复回复
            if (row.rawStatus === 2) {
                this.$message.warning('该问题已回复，不能重复回复')
                return
            }

            // 打开回复弹窗
            this.replyDialog.visible = true
            this.replyDialog.complaintCode = row.complaintCode
            this.replyDialog.questionTitle = row.questionTitle
            this.replyDialog.questionContent = row.questionContent

            // 重置表单
            this.replyDialog.form = {
                replyContent: '',
                replyContact: '',
                replyPhone: '',
                replyFileGuid: ''
            }
            this.replyDialog.questionFiles = []
            this.replyDialog.replyFileList = []
            this.replyDialog.uploadProgress = 0

            // 清除表单验证
            this.$nextTick(() => {
                if (this.$refs.replyForm) {
                    this.$refs.replyForm.clearValidate()
                }
            })
            this.getComplainDetail(row)
        },
        async getComplainDetail(row) {
            const res = await getComplainDetail(this.complaintType, { complaintCode: row.complaintCode })
            if (res.code === 200 && res.data.submitFileGuid) {
                await this.getQuestionFileList(res.data.submitFileGuid)
            }
        },
        // 获取问题附件列表
        async getQuestionFileList(fileGuid) {
            try {
                const res = await getFileList(fileGuid)
                if (res.code === 200) {
                    this.replyDialog.questionFiles = res.data || []
                }
            } catch (error) {
                console.error('获取附件列表失败:', error)
                this.replyDialog.questionFiles = []
            }
        },

        // 取消回复
        handleCancelReply() {
            this.replyDialog.visible = false
        },

        // 提交回复
        handleSubmitReply() {
            this.$refs.replyForm.validate(async (valid) => {
                if (valid) {
                    this.replyDialog.submitting = true

                    try {
                        // 先上传回复附件
                        let replyFileGuid = ''
                        if (this.replyDialog.replyFileList.length > 0) {
                            replyFileGuid = await this.uploadReplyFiles()
                            if (!replyFileGuid) {
                                this.replyDialog.submitting = false
                                return
                            }
                        }

                        // 提交回复
                        const data = {
                            complaintType: this.complaintType,
                            complaintCode: this.replyDialog.complaintCode,
                            replyContent: this.replyDialog.form.replyContent,
                            replyContact: this.replyDialog.form.replyContact,
                            replyPhone: this.replyDialog.form.replyPhone,
                            replyFileGuid: replyFileGuid
                        }

                        const res = await submitComplainReply(this.complaintType, data)

                        if (res.code === 200) {
                            this.$message.success('回复成功')
                            this.replyDialog.visible = false
                            this.getComplainList()
                        } else {
                            this.$message.error(res.msg || '回复失败')
                        }
                    } catch (error) {
                        console.error('回复失败:', error)
                        this.$message.error('回复失败，请重试')
                    } finally {
                        this.replyDialog.submitting = false
                        this.replyDialog.uploadProgress = 0
                    }
                } else {
                    this.$message.warning('请填写完整信息')
                    return false
                }
            })
        },

        // 上传回复附件
        async uploadReplyFiles() {
            const fileGuidList = []
            const totalFiles = this.replyDialog.replyFileList.length

            for (let i = 0; i < totalFiles; i++) {
                const fileItem = this.replyDialog.replyFileList[i]
                const file = fileItem.raw

                try {
                    const result = await doFileUpload(file, {
                        fileBindId: '',
                        onProgress: (percentage) => {
                            const baseProgress = (i / totalFiles) * 100
                            const currentProgress = (percentage / totalFiles)
                            this.replyDialog.uploadProgress = Math.floor(baseProgress + currentProgress)
                        }
                    })

                    if (result.success && result.fileGuid) {
                        fileGuidList.push(result.fileGuid)
                    } else {
                        this.$message.error(`文件 ${file.name} 上传失败`)
                        return null
                    }
                } catch (error) {
                    this.$message.error(`文件 ${file.name} 上传失败：${error.message}`)
                    return null
                }
            }

            this.replyDialog.uploadProgress = 100
            return fileGuidList.join(',')
        },

        // 查看按钮点击
        handleView(row) {
            this.$message.info(`查看问题：${row.questionTitle}`)
        },

        // 分页大小改变
        handleSizeChange(val) {
            this.pageSize = val
            this.currentPage = 1
            this.getComplainList()
        },

        // 当前页改变
        handleCurrentChange(val) {
            this.currentPage = val
            this.getComplainList()
        }
    }
}
</script>

<style lang="less" scoped>
@import '@/styles/minimal-gray-theme.less';

.agent-page {
    .apply-minimal-gray-theme();
}

.page-header {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    margin-bottom: 20px;
    gap: 20px;

    .page-title {
        font-size: 16px;
        font-weight: 600;
        color: @gray-700;
        margin: 0;
        line-height: 1.5;
        position: relative;
        padding-left: 10px;

        &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 50%;
            transform: translateY(-50%);
            width: 3px;
            height: 16px;
            background: @gray-700;
            border-radius: 2px;
        }

        &:first-child::before {
            background: @primary-color;
        }
    }

    /deep/ .el-button {
        transition: all @transition-base ease;
        &:hover { transform: translateY(-1px); }
    }
}

.agent-page {
    .main-content {
        margin-top: 20px;
        overflow: hidden;

        .table-container {
            .question-table {
                .el-table__header {
                    th {
                        background-color: #f8fafc;
                        color: #64748b;
                        font-weight: 500;
                        border-color: #e2e8f0;
                    }
                }

                .el-table__body {
                    td {
                        color: #1f2937;
                        border-color: #e2e8f0;
                    }
                }
            }

            .pagination-section {
                display: flex;
                justify-content: flex-end;
                border-radius: 8px;
            }
        }
    }
}

// 回复弹窗样式
::v-deep .el-dialog {
    .question-info-section {
        background: #f7f9fc;
        padding: 16px;
        border-radius: 6px;
        margin-bottom: 8px;

        .info-text {
            color: #303133;
            line-height: 1.6;
            font-size: 14px;
        }

        .question-content {
            max-height: 120px;
            overflow-y: auto;
            padding: 8px 12px;
            background: #fff;
            border-radius: 4px;
            border: 1px solid #e4e7ed;
        }

        // 问题附件列表（只读）
        .file-list-readonly {
            .file-item-readonly {
                display: flex;
                align-items: center;
                padding: 10px 12px;
                background: #fff;
                border: 1px solid #e4e7ed;
                border-radius: 4px;
                margin-bottom: 8px;
                transition: all 0.3s;

                &:hover {
                    border-color: #409eff;
                    background: #f0f7ff;
                }

                &:last-child {
                    margin-bottom: 0;
                }

                .el-icon-document {
                    font-size: 18px;
                    color: #409eff;
                    margin-right: 10px;
                }

                .file-name {
                    flex: 1;
                    font-size: 13px;
                    color: #303133;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-right: 12px;
                }

                .file-size {
                    font-size: 12px;
                    color: #909399;
                    margin-right: 12px;
                    min-width: 70px;
                    text-align: right;
                }

                .el-button--text {
                    padding: 0;
                    color: #409eff;

                    &:hover {
                        color: #66b1ff;
                    }

                    i {
                        margin-right: 2px;
                    }
                }
            }
        }

        .no-files {
            color: #909399;
            font-size: 13px;
            padding: 8px 0;
        }
    }

    .el-divider {
        margin: 20px 0;
    }

    .reply-info-section {
        .upload-section {
            .upload-area {
                .el-upload {
                    width: 100%;
                }

                .upload-tip {
                    font-size: 12px;
                    color: #909399;
                    line-height: 1.6;
                    margin-top: 8px;

                    .el-icon-info {
                        color: #409eff;
                        margin-right: 4px;
                    }
                }
            }

            .upload-progress {
                margin-top: 12px;
                padding: 12px;
                background: #f0f7ff;
                border-radius: 4px;
            }
        }
    }

    .dialog-footer {
        display: flex;
        justify-content: center;
        gap: 12px;
        padding-top: 8px;
    }
}
</style>
